import { useMutation } from "@tanstack/react-query";
import { postHprAadhaarOtp } from "apis";

const usePostHprAadhaarOtp = () => {
  return useMutation(postHprAadhaarOtp);
};

export default usePostHprAadhaarOtp;
